/* eslint-disable react/no-unused-prop-types */
import React from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';
import PropTypes from 'prop-types';

import { NEStepBranchSelection } from 'components/NEComponents/NESteps/NEStepBranchSelection/NEStepBranchSelection';
import { NEStepEmailInput } from 'components/NEComponents/NESteps/NEStepEmailInput/NEStepEmailInput';
import { NEStepForm } from 'components/NEComponents/NESteps/NEStepForm/NEStepForm';
import { NEStepFormUpload } from 'components/NEComponents/NESteps/NEStepFormUpload/NEStepFormUpload';
import { NEStepsContainer } from 'components/NEComponents/NEStepsContainer/NEStepsContainer';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';

import { NE_ACTIVE_STEP } from 'global/constants';

import {
  parseAEMDatapolicyProps,
  parseAEMSelfDeclarationCompanyFacilityProps,
} from 'utils/AEMPropUtils';

import './NEForm.sass';

export const NEForm = (props) => {
  const isEditor = Utils.isInEditor();
  const {
    expertQualificationCertificateGasLink,
    expertQualificationCertificateEnergyLink,
    installerContractMeterInstallationGasLink,
    installerContractMeterInstallationEnergyLink,
    installerContractSealing,
    gasAgreementLink,
    energyAgreementLink,
    installerContractLink,
    installerContractLinkEENGLink,
    installerContractLinkNNNGLink,
    installerContractLinkHANSGLink,
  } = props;
  if (isEditor) {
    return <RenderAemComponent componentProps={props} name="NewEntryForm" />;
  }
  return (
    <div className="ne-form">
      <div className="ne-form__container">
        <NEStepsContainer>
          <NEStepEmailInput key={NE_ACTIVE_STEP.EMAIL_INPUT} />
          <NEStepBranchSelection key={NE_ACTIVE_STEP.BRANCH_SELECTION} />
          <NEStepForm
            key={NE_ACTIVE_STEP.FORM}
            energyAgreementLink={energyAgreementLink}
            gasAgreementLink={gasAgreementLink}
          />
          <NEStepFormUpload
            key={NE_ACTIVE_STEP.FORM_UPLOAD}
            expertQualificationCertificateGasLink={expertQualificationCertificateGasLink}
            installerContractLinkNNNGLink={installerContractLinkNNNGLink}
            installerContractLinkEENGLink={installerContractLinkEENGLink}
            installerContractLinkHANSGLink={installerContractLinkHANSGLink}
            installerContractLink={installerContractLink}
            expertQualificationCertificateEnergyLink={expertQualificationCertificateEnergyLink}
            selfDeclarationCompanyFacilityLink={parseAEMSelfDeclarationCompanyFacilityProps(props)}
            dataPolicyDocuments={parseAEMDatapolicyProps(props)}
            installerContractMeterInstallationGasLink={installerContractMeterInstallationGasLink}
            installerContractMeterInstallationEnergyLink={
              installerContractMeterInstallationEnergyLink
            }
            installerContractSealing={installerContractSealing}
          />
        </NEStepsContainer>
      </div>
    </div>
  );
};

NEForm.displayName = 'NEForm';

NEForm.propTypes = {
  expertQualificationCertificateGasLink: PropTypes.string,
  expertQualificationCertificateEnergyLink: PropTypes.string,
  installerContractMeterInstallationGasLink: PropTypes.string,
  installerContractMeterInstallationEnergyLink: PropTypes.string,
  installerContractSealing: PropTypes.string,
  installerContractLink: PropTypes.string,
  installerContractLinkEENGLink: PropTypes.string,
  installerContractLinkNNNGLink: PropTypes.string,
  installerContractLinkHANSGLink: PropTypes.string,
  selfDeclarationCompanyFacilityLink: PropTypes.string,
  selfDeclarationCompanyFacilityNNNGLink: PropTypes.string,
  selfDeclarationCompanyFacilityLinkMTNEnergy: PropTypes.string,
  selfDeclarationCompanyFacilityLinkMTNGas: PropTypes.string,
  gasAgreementLink: PropTypes.string,
  energyAgreementLink: PropTypes.string,
  datapolicyEDILink: PropTypes.string,
  datapolicyAVALink: PropTypes.string,
  datapolicySHNGLink: PropTypes.string,
  datapolicyBAGLink: PropTypes.string,
  datapolicyEENGLink: PropTypes.string,
  datapolicyHANSGLink: PropTypes.string,
  datapolicyNNNGLink: PropTypes.string,
  datapolicyEDILabel: PropTypes.string,
  datapolicyAVALabel: PropTypes.string,
  datapolicyBAGLabel: PropTypes.string,
  datapolicySHNGLabel: PropTypes.string,
  datapolicyEENGLabel: PropTypes.string,
  datapolicyHANSGLabel: PropTypes.string,
  datapolicyNNNGLabel: PropTypes.string,
};

NEForm.defaultProps = {
  expertQualificationCertificateGasLink: '',
  expertQualificationCertificateEnergyLink: '',
  installerContractMeterInstallationGasLink: '',
  installerContractMeterInstallationEnergyLink: '',
  installerContractSealing: '',
  installerContractLink: '',
  installerContractLinkEENGLink: '',
  installerContractLinkNNNGLink: '',
  installerContractLinkHANSGLink: '',
  selfDeclarationCompanyFacilityLink: '',
  selfDeclarationCompanyFacilityNNNGLink: '',
  selfDeclarationCompanyFacilityLinkMTNEnergy: '',
  selfDeclarationCompanyFacilityLinkMTNGas: '',
  gasAgreementLink: '',
  energyAgreementLink: '',
  datapolicyEDILink: '',
  datapolicyAVALink: '',
  datapolicySHNGLink: '',
  datapolicyBAGLink: '',
  datapolicyEENGLink: '',
  datapolicyHANSGLink: '',
  datapolicyNNNGLink: '',
  datapolicyEDILabel: '',
  datapolicyAVALabel: '',
  datapolicyBAGLabel: '',
  datapolicySHNGLabel: '',
  datapolicyEENGLabel: '',
  datapolicyHANSGLabel: '',
  datapolicyNNNGLabel: '',
};

MapTo(['e-fix/components/content/newentry'])(NEForm);
